import { useState } from 'react';

import { LottieAnimation } from 'components/LottieAnimation/LottieAnimation';
import { useTooltipContext } from 'components/Tooltip/TooltipContext';
import type { CmsApiReactionType } from 'modules/cms/api/reactions/types/CmsApiReactionType';
import { REACTIONS } from 'modules/cms/constants/reactions';

import {
  CmsReactionTooltipContainer,
  CmsReactionTooltipIcon,
  CmsReactionTooltipIconContainer,
  CmsReactionTooltipLabel,
} from './CmsReactionButton.styled';

type Props = {
  onClickReaction: (reactionType: CmsApiReactionType) => void;
};

export function CmsReactionButtonTooltip({ onClickReaction }: Props) {
  const { closeTooltip } = useTooltipContext();

  const [hoveredReaction, setHoveredReaction] = useState<string | null>(null);

  return (
    <CmsReactionTooltipContainer data-qa-id="cms-reactions-tooltip">
      {Object.entries(REACTIONS).map(([key, { animation, qaId }]) => (
        <CmsReactionTooltipIconContainer key={key}>
          <CmsReactionTooltipLabel
            key={`${key}-label`}
            $active={key === hoveredReaction}
          >
            {REACTIONS[key as CmsApiReactionType].text}
          </CmsReactionTooltipLabel>
          <CmsReactionTooltipIcon
            key={key}
            data-qa-id={qaId}
            onMouseEnter={() => {
              setHoveredReaction(key);
            }}
            onMouseLeave={() => setHoveredReaction(null)}
            onClick={() => {
              onClickReaction(key as CmsApiReactionType);
              closeTooltip();
            }}
          >
            <LottieAnimation
              data={animation}
              size={{ width: 24, height: 24 }}
            />
          </CmsReactionTooltipIcon>
        </CmsReactionTooltipIconContainer>
      ))}
    </CmsReactionTooltipContainer>
  );
}
